import { canManageTeam } from '@indutrust/company-util';
import { resolveDemoAuthUserTeamRole } from '@indutrust/shared-mock-backend';
import { HttpResponse } from 'msw';

export const FACTORY_MUTATION_CAP_VIOLATION_MESSAGE =
  'Factory mutation not permitted for your role';

/** Returns a 403 response when the active demo persona is a Viewer. */
export function denyFactoryMutationForViewer(): ReturnType<
  typeof HttpResponse.json
> | null {
  if (!canManageTeam(resolveDemoAuthUserTeamRole())) {
    return HttpResponse.json(
      { message: FACTORY_MUTATION_CAP_VIOLATION_MESSAGE },
      { status: 403 }
    );
  }
  return null;
}
